import {
  AdminMembersReportPageParams,
  AdminMembersReportPageStartDate,
} from "@/admin/insights/member-reports/AdminMembersReportPage"
import MemberReportEngagementScoreStatisticCard from "@/admin/insights/member-reports/common/MemberReportEngagementScoreStatisticCard"
import MemberReportEventsAttendedStatisticCard from "@/admin/insights/member-reports/common/MemberReportEventsAttendedStatisticCard"
import MemberReportProductsRegisteredStatisticCard from "@/admin/insights/member-reports/common/MemberReportProductsRegisteredStatisticCard"
import { MemberReportStatisticCardSkeleton } from "@/admin/insights/member-reports/common/MemberReportStatisticCard"
import MemberReportStatisticCards, {
  MemberReportStatisticCardsSkeleton,
} from "@/admin/insights/member-reports/common/MemberReportStatisticCards"
import { AdminMembersReportOverviewTabStatisticsCardsQuery } from "@/admin/insights/member-reports/tabs/overview/__generated__/AdminMembersReportOverviewTabStatisticsCardsQuery.graphql"
import Relay from "@/relay/relayUtils"
import { useQueryParamState } from "@disco-ui/tabs/DiscoQueryParamTabs"
import { graphql } from "relay-runtime"

interface AdminMembersReportOverviewTabStatisticsCardsProps {
  filters: {
    startDate: AdminMembersReportPageStartDate
  }
}

function AdminMembersReportOverviewTabStatisticsCards({
  filters,
}: AdminMembersReportOverviewTabStatisticsCardsProps) {
  const [queryParams] = useQueryParamState<AdminMembersReportPageParams>()
  const [{ node }] =
    Relay.useRefetchableQuery<AdminMembersReportOverviewTabStatisticsCardsQuery>(
      graphql`
        query AdminMembersReportOverviewTabStatisticsCardsQuery(
          $id: ID!
          $startDate: String
        ) {
          node(id: $id) {
            __typename
            ... on OrganizationMembership {
              id
              ...MemberReportProductsRegisteredStatisticCardFragment
                @arguments(startDate: $startDate)
              ...MemberReportEventsAttendedStatisticCardFragment
                @arguments(startDate: $startDate)
              ...MemberReportEngagementScoreStatisticCardFragment
                @arguments(startDate: $startDate)
            }
          }
        }
      `,
      {
        id: queryParams.om!,
        startDate: filters.startDate,
      },
      {
        fetchPolicy: "network-only",
      }
    )

  const organizationMembership = Relay.narrowNodeType(node, "OrganizationMembership")
  if (!organizationMembership) return null

  return (
    <MemberReportStatisticCards>
      <MemberReportProductsRegisteredStatisticCard
        organizationMembershipKey={organizationMembership}
      />
      <MemberReportEventsAttendedStatisticCard
        organizationMembershipKey={organizationMembership}
      />
      <MemberReportEngagementScoreStatisticCard
        organizationMembershipKey={organizationMembership}
      />
    </MemberReportStatisticCards>
  )
}

function AdminMembersReportOverviewTabStatisticsCardsSkeleton() {
  return (
    <MemberReportStatisticCardsSkeleton>
      <MemberReportStatisticCardSkeleton />
      <MemberReportStatisticCardSkeleton />
      <MemberReportStatisticCardSkeleton />
    </MemberReportStatisticCardsSkeleton>
  )
}

export default Relay.withSkeleton({
  component: AdminMembersReportOverviewTabStatisticsCards,
  skeleton: AdminMembersReportOverviewTabStatisticsCardsSkeleton,
})
